'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var integer = {};

exports.__exports = integer;
